export const API_ROUTES = {
  AUTHENTICATE_CODES: `/wp/planner/authentication/codes`,
  AUTHENTICATE_SESSIONS: `/wp/planner/authentication/sessions`,
  CORE: {
    translation: (languageCid: string, scope: string): string =>
      `/core/translation/${encodeURIComponent(languageCid)}.json?scope=${encodeURIComponent(scope)}`,
  },
  DEALER: {
    config: (dealerId: string): string => `/wp/dealer/${dealerId}`,
  },
  USER: {
    profile: (email: string): string => `/wp/planner/user/${email}`,
  },
  VEHICLE: {
    connectivityMileage: (licensePlate: string): string =>
      `/wp/planner/vehicle-connectivity/${licensePlate}/mileage`,
    connectivityServiceIntervals: (licensePlate: string): string =>
      `/wp/planner/vehicle-connectivity/${licensePlate}/service-intervals`,
    info: (licensePlate: string): string => `/wp/planner/vehicle-information/${licensePlate}`,
  },
  PLANNER: {
    logout: (): string => `/wp/planner/logout`,
    jobs: (licensePlate: string, mileage?: number): string =>
      `/wp/planner/jobs?licensePlate=${encodeURIComponent(licensePlate)}` +
      (mileage != null ? `&mileage=${mileage}` : ''),
    jobsSubmit: (): string => `/wp/planner/jobs`,
    establishments: (licensePlate: string): string =>
      `/wp/planner/establishments?licensePlate=${encodeURIComponent(licensePlate)}`,
    calendar: (establishmentId: number, year: number, month: number): string =>
      `/wp/planner/calendar?establishmentId=${establishmentId}&year=${year}&month=${month}`,
    calendarAppointmentOptions: (establishmentId: number, date: string): string =>
      `/wp/planner/calendar/appointment-options?establishmentId=${establishmentId}&date=${encodeURIComponent(date)}`,
    replacementVehicles: (establishmentId: number, date: string): string =>
      `/wp/planner/replacement-vehicles?establishmentId=${establishmentId}&date=${encodeURIComponent(date)}`,
    appointment: (): string => `/wp/planner/appointment`,
    carBrands: (): string => `/wp/planner/car-brands`,
    state: (): string => `/wp/planner/state`,
    lease: (licensePlate: string): string =>
      `/wp/planner/lease?licensePlate=${encodeURIComponent(licensePlate)}`,
    addresses: (zipCode: string, houseNumber: string, houseNumberSuffix: string): string =>
      `/wp/planner/addresses?zipCode=${encodeURIComponent(zipCode)}&houseNumber=${encodeURIComponent(houseNumber)}` +
      (houseNumberSuffix ? `&houseNumberSuffix=${encodeURIComponent(houseNumberSuffix)}` : ''),
  },
};

export type ApiRouteKey = keyof typeof API_ROUTES;
